"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomNumber = void 0;
exports.randomNumber = (min, max) => Math.floor(Math.random() * (max - min + 1) + min);
//# sourceMappingURL=random-number.js.map